



































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import { sleep } from '@ivy/fts/utils'
import GoodsInfo from '../comps/goods-info.vue'
import showDiv from '@ivy/fts/showDiv'

@Component
export default class MyTeam extends Vue {
  @Prop() attendInfo: any
  @Prop() publicInfo: any
  @Prop() isPhysical: boolean
  @Prop() status: any
  @Prop() activityId: any
  @Prop() invitedId: any
  @Prop() myTeamId: any
  @Prop() shareAppName: any
  @Prop() memId: any
  @Prop() isConfirmed: boolean
  //是否是队长1是 2不是
  @Prop() userType: any
  nologinList: any = []
  need_num: number = 0
  btn_text: string = ''
  canClick: boolean = true
  appMapper: any = {
    ivydad: '常青藤爸爸App',
    ivydad_eduai: '小小常爱学习App',
    ivydad_literacy: '小小常爱识字App',
  }
  showMoreIcon: boolean = false //是否限时可滑动图标
  @Watch('myTeamId')
  async onIdChange(val) {
    await this.initTeamInfo()
  }
  @Watch('status')
  async onStatusChange(val) {
    await this.initTeamInfo()
  }
  @Watch('attendInfo')
  async onInfoChange(val) {
    await this.initTeamInfo()
  }
  @Watch('isConfirmed')
  async onComfirmChange(val) {
    this.initTeamInfo()
  }
  @Watch('invitedId')
  async onInviteIdChange(val) {
    this.initTeamInfo()
  }
  async created() {
    await this.initTeamInfo()
  }
  mounted() {
    // 判断是否限时可滑动图标
    let invitedEl = document.querySelector('.invited')
    if (invitedEl) {
      let conWidth = invitedEl.scrollWidth
      let posWidth = invitedEl.clientWidth
      if (conWidth - posWidth > 0) {
        this.showMoreIcon = true
      }
    }
  }
  showList = []
  stageTable = {}
  //当前所处阶段
  nowStage = 1
  //当前阶段还需要邀请人数
  nowInviteCount = 0
  //初始化展示的组队数据
  initShowInfo() {
    //zmtest

    // this.publicInfo.config = {
    //   stage_info: {
    //     1: { stage_need_num: 2, stage_limit: 10 },
    //     2: { stage_need_num: 3, stage_limit: 10 },
    //   },
    //   stage_num: 2,
    // }
    if (Object.keys(this.stageTable).length > 0) {
      //先把队长放进去
      this.showList.push({
        type: 1,
        data: this.stageTable[0] && this.stageTable[0][0],
      })
      if (this.publicInfo.config.stage_info) {
        for (let key in this.publicInfo.config.stage_info) {
          let item = this.publicInfo.config.stage_info[key]
          let count = item.stage_need_num
          for (let i = 0; i < count; i++) {
            this.showList.push({
              type: 1,
              data: this.stageTable[key] && this.stageTable[key][i],
            })
            //当前阶梯最后一个，把奖励加进去 只有一级阶梯 不加进去
            if (i === count - 1 && this.publicInfo.config.stage_num > 1) {
              this.showList.push({
                type: 2,
                txt: '查看奖品',
                goods: item.reward_info,
                // Number(key) === 1
                //   ? '邀' + Number(item.stage_need_num) + '人可得'
                //   : '再邀' + Number(item.stage_need_num) + '人可得',
              })
            }
          }
        }
      }
    }
  }
  //根据阶梯处理邀请的数据 分阶梯存贮
  initInivteInfo(data, stage) {
    if (!this.stageTable[stage]) {
      this.stageTable[stage] = []
    }
    this.stageTable[stage].push(data)
  }
  async initTeamInfo() {
    this.nologinList.length = 0
    this.stageTable = {}
    this.showList.length = 0
    if (this.attendInfo && this.attendInfo.length > 0) {
      for (let team of this.attendInfo) {
        if (
          team.is_organizer ||
          (team.status !== 'no_login' && team.is_login)
        ) {
          if (team.is_organizer) {
            //把队长放到首个展示 不属于任何一个阶梯
            //zmtest
            // team.stage = 1
            this.initInivteInfo(team, 0)
          } else {
            //zmtest
            // team.stage = 1
            this.initInivteInfo(team, team.stage)
          }
        } else {
          this.nologinList.push(team)
        }
      }
      //当前阶梯取队长的阶梯
      this.nowStage = this.stageTable[0][0].stage
    }
    //初始化队员展示数据
    this.initShowInfo()
    this.initBtnState()
  }
  //判断当前是否登录过引导app true 未登录 false  已登录
  getIsNoLogin() {
    debugger
    let nologinList = this.attendInfo.filter(
      team => team.status == 'no_login' && !team.is_organizer
    )
    if (nologinList.findIndex(el => el.mem_id === +this.memId) !== -1) {
      return true
    }
    return false
  }
  //初始化按钮状态
  initBtnState() {
    if (+new Date() < +new Date(this.publicInfo.end_time.replace(/-/g, '/'))) {
      if (
        !this.publicInfo.config.stage_info[this.publicInfo.config.stage_num] ||
        !this.publicInfo.config.stage_info[this.publicInfo.config.stage_num]
          .stage_limit
      ) {
        //最后一阶的奖励没有了 活动直接结束
        this.btn_text = '活动已结束'
        return
      }
      //结束时间未到
      //加入当前进来的组队
      if (this.myTeamId) {
        //如果当前队伍的阶梯奖励还有
        if (
          this.publicInfo.config.stage_info[this.nowStage] &&
          this.publicInfo.config.stage_info[this.nowStage].stage_limit
        ) {
          if (this.userType == 1) {
            if (this.status === 'TEAM_HAS_SUCCESS') {
              if (this.isConfirmed) {
                this.canClick = false
                this.btn_text = '组队成功'
                return
              }
              this.btn_text = !this.isPhysical
                ? '组队成功'
                : '填写/修改收货地址'
            } else if (this.status === 'TEAM_IS_WAITING') {
              //当前阶梯还需邀请数=当前阶梯总数-当前阶梯内已有人数
              this.need_num =
                this.publicInfo.config.stage_info[this.nowStage]
                  .stage_need_num -
                ((this.stageTable[this.nowStage] &&
                  this.stageTable[this.nowStage].length) ||
                  0)
              if (this.nowStage == 1) {
                this.btn_text = `再邀请${this.need_num}人免费领`
              } else {
                this.btn_text = `再邀请${this.need_num}人可继续领`
              }
            } else if (this.status === 'TEAM_HAS_FAIL') {
              this.btn_text = '重新发起组队'
            } else {
              this.btn_text = '发起组队'
            }
          } else if (this.userType == 2) {
            if (this.status === 'TEAM_HAS_SUCCESS') {
              //如果已确认地址 发起组队
              if (this.isConfirmed) {
                this.btn_text = '发起组队'
                return
              }
              this.btn_text = !this.isPhysical
                ? '发起组队'
                : '填写/修改收货地址'
            } else if (this.status === 'TEAM_IS_WAITING') {
              //是队员 显示发起组队，到底是否能发起放到按钮点击里处理
              this.btn_text = '发起组队'
            } else if (this.status === 'TEAM_HAS_FAIL') {
              this.btn_text = '发起组队'
            } else {
              this.btn_text = '发起组队'
            }
          }
        } else {
          //奖励没有了 活动已结束
          this.btn_text = '活动已结束'
        }
      } else {
        //还未加入该组队
        if (this.invitedId && this.status === 'TEAM_IS_WAITING') {
          //邀请人当前的奖励已无 活动结束
          if (
            this.publicInfo.config.stage_info[this.nowStage] &&
            this.publicInfo.config.stage_info[this.nowStage].stage_limit
          ) {
            this.btn_text = '加入组队免费领'
          } else {
            this.btn_text = '活动已结束'
          }
        } else {
          if (
            !this.publicInfo.config.stage_info[1] ||
            !this.publicInfo.config.stage_info[1].stage_limit
          ) {
            this.btn_text = '活动已结束'
          } else {
            this.btn_text = '发起组队'
          }
        }
      }
    } else {
      //时间已结束
      this.btn_text = '活动已结束'
    }
  }
  getClassName(i) {
    return (i && 'notEmpty') || ''
  }
  getAvatar(i) {
    return i ? i.avatar_url : require('../imgs/empty-avatar.png')
  }
  getNickName(i) {
    return i ? i.user_nick : '待邀请'
  }
  getIsLogin(i) {
    return i && i.is_login
  }

  async handlerAction() {
    if (this.canClick) {
      this.$emit('handlerAction')
    }
  }
  showTips() {
    this.$Toast(
      `以下好友需要登录“${
        this.appMapper[this.shareAppName]
      }”才可以领取成功，快去提醒TA们吧`
    )
  }
  async goToRecord() {
    this.$router.push({
      path: `/teamFree/teamRecord`,
      query: {
        activityId: this.activityId,
        _hideShareButton: '1',
      },
    })
  }
  async goToRecordOther() {
    this.$router.push({
      path: `/teamFree/teamRecord`,
      query: {
        activityId: this.activityId,
        _hideShareButton: '1',
        tab: '2',
      },
    })
  }
  toService() {
    this.$emit('toService')
  }
  async showGift(item) {
    console.log('rrrr', item)
    let { data } = await this.$axios.get(
      '/api/activity/appActivity/teamActivity/getRewardInfo',
      {
        params: {
          sku_id: item.goods.sku_id,
          type: item.goods.type,
        },
      }
    )
    showDiv(GoodsInfo, {
      goods: data || {},
    })
  }
}
